import posterSendCountConfirmationDialog from './creation/SendLimitedCountConfirmationDialog';
import posterSendSelectionConfirmationDialog from './creation/SendSelectionConfirmationDialog';
import posterDashboardDemandsSynthesis from './dashboard/DashboardDemandsSynthesis';
import puiDemandsSynthesis from './dashboard/DashboardDemandsSynthesis.vue';
import posterDashboardShortcut from './dashboard/DashboardShortcut';
import posterDashboardWelcomeWidget from './dashboard/DashboardWelcomeWidget';
import posterDashboardWidget from './dashboard/DashboardWidget';
import puiDocumentViewer from './DocumentViewer';
import posterGalleryThumbnail from './GalleryThumbnail';
import posterForm from './search/SearchForm';
import posterModeSelector from './search/SearchModeSelector';
import posterSearchPanel from './search/SearchPanel';
import posterSearchSummary from './search/SearchSummary';
import posterTypeGallery from './selector/TypeGallery';
import posterValidationAlert from './ValidationAlert';

export {
  puiDemandsSynthesis,
  puiDocumentViewer,
  posterGalleryThumbnail,
  posterSearchPanel,
  posterSearchSummary,
  posterValidationAlert,
  posterDashboardShortcut,
  posterDashboardWidget,
  posterDashboardDemandsSynthesis,
  posterDashboardWelcomeWidget,
  posterModeSelector,
  posterForm,
  posterTypeGallery,
  posterSendSelectionConfirmationDialog,
  posterSendCountConfirmationDialog,
};

export const components = [
  puiDemandsSynthesis,
  puiDocumentViewer,
  posterGalleryThumbnail,
  posterSearchPanel,
  posterSearchSummary,
  posterValidationAlert,
  posterDashboardShortcut,
  posterDashboardWidget,
  posterDashboardDemandsSynthesis,
  posterDashboardWelcomeWidget,
  posterModeSelector,
  posterForm,
  posterTypeGallery,
  posterSendSelectionConfirmationDialog,
  posterSendCountConfirmationDialog,
];
